import React, { Component, Fragment } from "react";
import api from "../../../services/api";
import FormMeta from "./FormMeta";
import SelectMeta from "./SelectMeta";
import SelectMes from "./SelectMes";
import SelectTipo from "./SelectTipo";
import TabelaMeta from "./TabelaMeta";
import utils from "../../../utils/utils";
import "./style.css";
import NomeUnidade from "../../UI/NomeUnidade";

export default class Metas extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            aplicationName: "Módulo de Metas",
            cursos: [],
            cursoSelecionado: {},
            metas: null,
            total: null,
            modalidade: "Todas",
            modalidadeMetas: "Todas",
            mes: "Anual",
            tipo: "Todos"
        }
    }

    recarregaDados = async () => {
        await this.loadMetas();
        await this.loadCursos();
        await this.calculaTotalUnidade();
    }

    async componentDidMount() {
        await this.recarregaDados();
    }

    loadCursos = async () => {
        let cursos = await api.get("/cursos");
        cursos = cursos.data.cursos

        // ordem alfabética
        cursos = utils.ordemAlfabeticaPorCurso(cursos)

        // filtro por modalidade
        cursos = utils.selectPorModalidade(cursos, this.state.modalidade);
        
        // filtro por unidade
        cursos = utils.selectPorUnidade(cursos, this.props.unidade);

        if(cursos.length < 1) {
            window.showNotification('Nenhum curso encontrado', 'warning');
            this.setState({
                cursos: cursos,
                cursoSelecionado: {
                    codigo: "",
                    unidade: "",
                    modalidade: "",
                    tipo: "",
                    turno: "",
                    curso: "",
                    cargaHoraria: ""
                }
            });
        }

        else {
            this.setState({ cursos: cursos  });
        }
    }

    loadMetas = async () => {
        let metas = await api.get("/metas");

        // filtro por modalidade
        metas = utils.selectPorModalidade(metas.data.metas, this.state.modalidadeMetas);
        
        // filtro por modalidade
        metas = utils.selectPorUnidade(metas, this.props.unidade);
        metas = this.verificaMes(metas);
        metas = this.verificaTipo(metas);

        this.setState({
            metas: metas
        });
    }

    verificaMes = (metas) => {
        let mes = this.state.mes;
        if(mes === 'Anual') return metas
        else {
            metas = metas.filter((meta, i) => {
                if(meta.metasMensais.numTurmas[mes]) return meta
            });
            return metas;
        }
    }

    verificaTipo = (metas) => {
        let tipo = this.state.tipo;
        if(tipo === 'Todos') return metas
        else {
            metas = metas.filter((meta, i) => {
                if(meta.tipo === tipo) return meta
            });
            return metas;
        }
    }

    onChange = async (event) => {
        let cod = event.target.value.split("-")[0]

        // filtra o curso pelo o código e pelo o nome da unidade
        let cursoSelecionado = this.state.cursos.filter(curso => {
            if(curso.codigo == cod && this.props.unidade.toUpperCase() === utils.parseUnidade(curso.unidade)) return curso;
        });

        this.setState({
            cursoSelecionado: cursoSelecionado[0]
        });

    }

    excluirMeta = async (curso) => {
        let status = await api.delete(`/metas/${curso}`);
        await this.recarregaDados();
        window.showNotification(typeof status.data.status === "string" ? status.data.status : 'Excluído com sucesso', 'danger');
    }

    calculaTotalUnidade = async () => {
        let t0 = this.state.metas && this.state.metas.reduce((acc, curr) => curr.metasMensais.total[0] !== undefined && curr.metasMensais.total[0] !== null ? acc + curr.metasMensais.total[0] : acc, 0);
        let t1 = this.state.metas && this.state.metas.reduce((acc, curr) => curr.metasMensais.total[1] !== undefined && curr.metasMensais.total[0] !== null ? acc + curr.metasMensais.total[1] : acc, 0);
        let t2 = this.state.metas && this.state.metas.reduce((acc, curr) => curr.metasMensais.total[2] !== undefined && curr.metasMensais.total[0] !== null ? acc + curr.metasMensais.total[2] : acc, 0);
        let t3 = this.state.metas && this.state.metas.reduce((acc, curr) => curr.metasMensais.total[3] !== undefined && curr.metasMensais.total[0] !== null ? acc + curr.metasMensais.total[3] : acc, 0);
        let t4 = this.state.metas && this.state.metas.reduce((acc, curr) => curr.metasMensais.total[4] !== undefined && curr.metasMensais.total[0] !== null ? acc + curr.metasMensais.total[4] : acc, 0);
        let t5 = this.state.metas && this.state.metas.reduce((acc, curr) => curr.metasMensais.total[5] !== undefined && curr.metasMensais.total[0] !== null ? acc + curr.metasMensais.total[5] : acc, 0);
        let t6 = this.state.metas && this.state.metas.reduce((acc, curr) => curr.metasMensais.total[6] !== undefined && curr.metasMensais.total[0] !== null ? acc + curr.metasMensais.total[6] : acc, 0);
        let t7 = this.state.metas && this.state.metas.reduce((acc, curr) => curr.metasMensais.total[7] !== undefined && curr.metasMensais.total[0] !== null ? acc + curr.metasMensais.total[7] : acc, 0);
        let t8 = this.state.metas && this.state.metas.reduce((acc, curr) => curr.metasMensais.total[8] !== undefined && curr.metasMensais.total[0] !== null ? acc + curr.metasMensais.total[8] : acc, 0);
        let t9 = this.state.metas && this.state.metas.reduce((acc, curr) => curr.metasMensais.total[9] !== undefined && curr.metasMensais.total[0] !== null ? acc + curr.metasMensais.total[9] : acc, 0);
        let t10 = this.state.metas && this.state.metas.reduce((acc, curr) => curr.metasMensais.total[10] !== undefined && curr.metasMensais.total[0] !== null ? acc + curr.metasMensais.total[10] : acc, 0);
        let total = [t0, t1, t2, t3, t4, t5, t6, t7, t8, t9, t10]
        this.setState({ total: total });
    }

    selectModalidade = async (event) => {
        this.setState({ modalidade: event.target.value });
        await this.recarregaDados();
    }

    selectMes = async (event) => {
        this.setState({ mes: event.target.value });
        await this.recarregaDados();
    }

    selectTipo = async (event) => {
        this.setState({ tipo: event.target.value });
        await this.recarregaDados();
    }

    selectModalidadeMetas = async (event) => {
        this.setState({ modalidadeMetas: event.target.value });
        await this.recarregaDados();
    }


    render() {
        return (
            <Fragment>
                
                <NomeUnidade unidade={this.props.unidade}/>

                <div className="content">
                    
                    <FormMeta 
                        selectModalidade={this.selectModalidade} 
                        cursos={this.state.cursos}
                        onChange={this.onChange}
                        cursoSelecionado={this.state.cursoSelecionado}
                        recarregaDados={this.recarregaDados}
                        unidade={this.props.unidade}
                    />

                    <div className="row">
                        <div className="col-md-8 ml-auto mr-auto">
                            <div className="card card-user">
                                <div className="card-header">
                                     <div className="row">
                                        <div className="col-md-12">
                                            <form>
                                                <div className="form-group">
                                                    <h5 className="card-title">Selecionar Modalidade</h5>
                                                    <SelectMeta selectModalidade={this.selectModalidadeMetas}/>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                     <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <h5 className="card-title">Selecionar Mês</h5>
                                                <SelectMes selectMes={this.selectMes}/>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <h5 className="card-title">Selecionar Tipo</h5>
                                                <SelectTipo selectTipo={this.selectTipo} />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                
                </div>

                <TabelaMeta 
                    metas={this.state.metas}
                    unidade={this.props.unidade}
                    total={this.state.total}
                    excluirMeta={this.excluirMeta}
                />

            </Fragment>
        )
    }
}